import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.regular};
  box-sizing: border-box;
  justify-self: center;
  padding-top: 52px;
  width: 60dvw;
  padding-bottom: ${({ theme }) => theme.spacing.spacingDesktop};

  ul {
    margin: 0;

    li {
      font-weight: 500;
    }
  }

  p {
    text-indent: 40px;
    text-align: justify;
  }

  @media (max-width: 1560px) {
    width: 70dvw;
  }
  @media (max-width: 1300px) {
    width: 80dvw;
  }
  @media (max-width: 1024px) {
    padding: 52px ${({ theme }) => theme.padding.regular}
      ${({ theme }) => theme.spacing.spacingTablet};
    width: 100%;
  }

  @media (max-width: 520px) {
    padding: ${({ theme }) => theme.padding.regular}
      ${({ theme }) => theme.padding.small}
      ${({ theme }) => theme.spacing.large};

    ul {
      font-size: ${({ theme }) => theme.typography.medium.fontSize};
    }
  }

  @media (min-width: 2500px) {
    padding-bottom: 180px;

    ul {
      font-size: 1.75rem;
    }
  }
  @media (min-width: 3000px) {
    padding-bottom: 200px;
    padding-top: ${({ theme }) => theme.padding.xlarge};

    ul {
      font-size: 2rem;
    }
  }
  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.medium};

    ul {
      font-size: 2.5rem;
    }
  }
  @media (min-width: 3500px) {
    padding-bottom: 220px;
  }
  @media (min-width: 3800px) {
    padding-bottom: 260px;
    gap: ${({ theme }) => theme.padding.large};

    ul {
      font-size: 3rem;
    }
  }
  @media (min-width: 4500px) {
    padding-bottom: 8dvw;
    gap: 52px;

    ul {
      font-size: 3.25rem;
    }
  }
  @media (min-width: 5000px) {
    ul {
      font-size: 3.75rem;
    }
  }
`;

export const SectionHeader = styled.h1`
  font-size: ${({ theme }) => theme.typography.h3.fontSize};
  font-weight: ${({ theme }) => theme.fontWeight.extrabold};
  margin: 0;
  text-transform: uppercase;
  text-align: center;
  word-spacing: ${({ theme }) => theme.spacing.xsmall};

  @media (max-width: 520px) {
    font-size: ${({ theme }) => theme.typography.body.fontSize};
  }
  @media (min-width: 2500px) {
    font-size: 2.275rem;
  }
  @media (min-width: 3400px) {
    font-size: 3rem;
  }
  @media (min-width: 3800px) {
    font-size: 3.5rem;
  }
  @media (min-width: 4500px) {
    font-size: 4rem;
  }
  @media (min-width: 5000px) {
    font-size: 4.25rem;
  }
`;

export const Subheader = styled.h4`
  font-size: ${({ theme }) => theme.typography.h4.fontSize};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  text-transform: uppercase;
  margin: 0;

  @media (max-width: 520px) {
    font-size: ${({ theme }) => theme.typography.body.fontSize};
  }

  @media (min-width: 2500px) {
    font-size: 2rem;
  }
  @media (min-width: 3000px) {
    font-size: 2.25rem;
  }
  @media (min-width: 3400px) {
    font-size: 2.75rem;
  }
  @media (min-width: 3800px) {
    font-size: 3.15rem;
  }
  @media (min-width: 4500px) {
    font-size: 3.5rem;
  }
  @media (min-width: 5000px) {
    font-size: 4rem;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.regular};
  align-items: center;

  p {
    text-indent: 0;
  }

  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.medium};
  }
  @media (min-width: 3800px) {
    gap: ${({ theme }) => theme.padding.large};
  }
  @media (min-width: 4500px) {
    gap: 52px;
  }
`;

export const SubheaderLine = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.regular};
  justify-content: center;
  align-items: center;

  button {
    align-self: inherit;
  }

  @media (max-width: 360px) {
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.small};
  }
`;

export const ButtonContent = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  align-items: center;

  i {
    font-size: 1rem;

    @media (max-width: 520px) {
      font-size: ${({ theme }) => theme.typography.small.fontSize};
    }

    @media (min-width: 2500px) {
      font-size: ${({ theme }) => theme.typography.body.fontSize};
    }
    @media (min-width: 3000px) {
      font-size: ${({ theme }) => theme.typography.h4.fontSize};
    }
    @media (min-width: 3400px) {
      font-size: ${({ theme }) => theme.typography.h3.fontSize};
    }
    @media (min-width: 3800px) {
      font-size: ${({ theme }) => theme.typography.h2.fontSize};
    }
    @media (min-width: 4500px) {
      font-size: 2.5rem;
    }
    @media (min-width: 5000px) {
      font-size: ${({ theme }) => theme.typography.h1.fontSize};
    }
  }

  @media (min-width: 3200px) {
    gap: ${({ theme }) => theme.spacing.regular};
  }
`;
